import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=1dc20891&scoped=true&"
import script from "./Logo.vue?vue&type=script&lang=js&"
export * from "./Logo.vue?vue&type=script&lang=js&"
import style0 from "./Logo.vue?vue&type=style&index=0&id=1dc20891&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../1013/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc20891",
  null
  
)

export default component.exports